import Service from "./Service";
const baseurl = '/api/valoraciones';

export default {
    index(codigo) {
        return Service.get(`${baseurl}/${codigo}`);
    }
}